import React from 'react';
import './css/OnlineTeacher.scss';
import ASK1 from './images/t1.png';
import ASK2 from './images/t2.png';
import ASK3 from './images/t3.png';
import ASK4 from './images/t4.png';
import ASK5 from './images/t5.png';
import ASK6 from './images/t6.png';
import ASK7 from './images/t7.png';
import STAR from './images/star.png';

const Online=(props)=>{
    return(
        <div className="container onlineteachers">
            <h1 className="Tutors-for-every-kind-of-learner">Tutors for every kind of learner</h1>
            <div className="row">
                <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 coloumns">
                    <div className="card coloumn">
                        <img className="image" src={ASK4} alt="ASK4"></img>
                        <div className="Rectangle-48">ONLINE</div>
                        <div className="body">
                            <div className="Name">CONOR</div>
                            <div className="Subjects">Maths <span className="dot"></span> Phsics <span className="dot"></span> Biology</div>
                            <div className="per-hour">&#163;20 per hour</div>
                            <div>
                                <img src={STAR} alt="img" style={{width: "10px",height:'10px'}}></img>
                                <span className="Rating">5.0<span className="Number">(152)</span></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 coloumns">
                    <div className="card coloumn">
                        <img className="image" src={ASK5} alt="ASK5"></img>
                        <div className="Rectangle-48">ONLINE</div>
                        <div className="body">
                            <div className="Name">CONOR</div>
                            <div className="Subjects">Maths <span className="dot"></span> Physics <span className="dot"></span> Biology</div>
                            <div className="per-hour">&#163;20 per hour</div>
                            <div>
                                <img src={STAR} alt="img" style={{width: "10px",height:'10px'}}></img>
                                <span className="Rating">5.0<span className="Number">(152)</span></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 coloumns">
                    <div className="card coloumn">
                        <img className="image" src={ASK6} alt="ASK6"></img>
                        <div className="Rectangle-48">ONLINE</div>
                        <div className="body">
                            <div className="Name">CONOR</div>
                            <div className="Subjects">Maths <span className="dot"></span> Phsics <span className="dot"></span> Biology</div>
                            <div className="per-hour">&#163;20 per hour</div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 coloumns">
                    <div className="card coloumn">
                        <img className="image" src={ASK7} alt="ASK7"></img>
                        <div className="Rectangle-48">ONLINE</div>
                        <div className="body">
                            <div className="Name">CONOR</div>
                            <div className="Subjects">Maths <span className="dot"></span> Phsics <span className="dot"></span> Biology</div>
                            <div className="per-hour">&#163;20 per hour</div>
                            <div>
                                <img src={STAR} alt="img" style={{width: "10px",height:'10px'}}></img>
                                <span className="Rating">5.0<span className="Number">(152)</span></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 coloumns">
                    <div className="card coloumn">
                        <img className="image" src={ASK1} alt="ASK1"></img>
                        <div className="Rectangle-48">ONLINE</div>
                        <div className="body">
                            <div className="Name">CONOR</div>
                            <div className="Subjects">Maths <span className="dot"></span> Phsics <span className="dot"></span> Biology</div>
                            <div className="per-hour">&#163;20 per hour</div>
                            <div>
                                <img src={STAR} alt="img" style={{width: "10px",height:'10px'}}></img>
                                <span className="Rating">5.0<span className="Number">(152)</span></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 coloumns">
                    <div className="card coloumn">
                        <img className="image" src={ASK2} alt="ASK2"></img>
                        <div className="Rectangle-48">ONLINE</div>
                        <div className="body">
                            <div className="Name">CONOR</div>
                            <div className="Subjects">Maths <span className="dot"></span> Phsics <span className="dot"></span> Biology</div>
                            <div className="per-hour">&#163;20 per hour</div>
                            <div>
                                <img src={STAR} alt="img" style={{width: "10px",height:'10px'}}></img>
                                <span className="Rating">5.0<span className="Number">(152)</span></span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 coloumns">
                    <div className="card coloumn">
                        <img className="image" src={ASK3} alt="ASK3"></img>
                        <div className="Rectangle-48">ONLINE</div>
                        <div className="body">
                            <div className="Name">CONOR</div>
                            <div className="Subjects">Maths <span className="dot"></span> Phsics <span className="dot"></span> Biology</div>
                            <div className="per-hour">&#163;20 per hour</div>
                        </div>
                    </div>
                </div>
                <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12 coloumns">
                    <div className="card coloumn">
                        <img className="image" src={ASK4} alt="ASK4"></img>
                        <div className="Rectangle-48">ONLINE</div>
                        <div className="body">
                            <div className="Name">CONOR</div>
                            <div className="Subjects">Maths <span className="dot"></span> Phsics <span className="dot"></span> Biology</div>
                            <div className="per-hour">&#163;20 per hour</div>
                            <div>
                                <img src={STAR} alt="img" style={{width: "10px",height:'10px'}}></img>
                                <span className="Rating">5.0<span className="Number">(152)</span></span>
                            </div>
                        </div>
                    </div>
                </div>
                <h2 className="Show-all-online-tutors"><b>Show all online tutors</b> &gt;</h2>
            </div>
        </div>
    );
}
export default Online;